import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AuthState } from '@app/modules/users';

@Component({
  selector: 'vip-page',
  templateUrl: './vip.component.html',
  styleUrl: './vip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'vip-page w-full flex'
  }
})
export default class VipComponent {
  public readonly authState = inject(AuthState);
}
